export default {
  SET_NOTIFICATION(state, { results, totalCount, totalUnread, page }) {
    state.data = results;
    state.totalCount = totalCount;
    state.totalUnread = totalUnread;
    state.page = page;
  }
};
